import * as React from 'react';
import { getStringTable } from '../../utilities/localizationUtilities.dynamic';
/**
 * Function that returns a promise that can be use with React.lazy that resolves after the code for the Leap Control
 * and string table have loaded
 */ export async function getLeapWithStrings(localization) {
    const [stringTable, fluidLeapModule] = await Promise.all([
        getStringTable(localization.locale),
        import(/* webpackChunkName: "leap" */ './FluidLeap')
    ]);
    return {
        default: (props)=>/*#__PURE__*/ React.createElement(fluidLeapModule.FluidLeap, {
                localization: localization,
                stringTable: stringTable,
                ...props
            })
    };
}
